import {css} from 'styled-components';

import type {ThemeColor} from '../../styles/theme';
import type {StyledProps} from './types';

import {ms} from '../../styles/normalizeSize';
import {getColor} from '../../styles/utils';

export const DEFAULT_HEIGHT = 23;

export const DEFAULT_WIDTH = 40;

export const OFFSET = 2;

export const DEFAULT_ACTIVE_COLOR: ThemeColor = 'global1';

export const DEFAULT_INACTIVE_COLOR: ThemeColor = 'icon3';

export const DEFAULT_ACTIVE_THUMB_COLOR: ThemeColor = 'global4';

export const DEFAULT_INACTIVE_THUMB_COLOR: ThemeColor = 'global4';

const containerBase = css<StyledProps>`
  height: ${p => ms(p.height || DEFAULT_HEIGHT)};
  width: ${p => ms(p.width || DEFAULT_WIDTH)};
  border-radius: ${p => ms(p.height || DEFAULT_HEIGHT)};
  position: relative;

  ${p =>
    p.isDisabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}
`;

export const containerWeb = css<StyledProps>`
  ${containerBase};
  box-sizing: border-box;
  transition: background-color 0.3s ease;
  background-color: ${p =>
    p.isActive
      ? getColor(p.backgroundActive || DEFAULT_ACTIVE_COLOR)(p)
      : getColor(p.backgroundInactive || DEFAULT_INACTIVE_COLOR)(p)};
`;

export const containerNative = css<StyledProps>`
  ${containerBase};
`;

const thumbBase = css<StyledProps>`
  height: ${p => ms((p.height || DEFAULT_HEIGHT) - OFFSET * 2)};
  width: ${p => ms((p.height || DEFAULT_HEIGHT) - OFFSET * 2)};
  border-radius: ${p => ms((p.height || DEFAULT_HEIGHT) - OFFSET * 2)};
  position: relative;
  top: ${ms(OFFSET)};
`;

export const thumbWeb = css<StyledProps>`
  ${thumbBase};
  transition: left 0.3s ease;
  background-color: ${p =>
    p.isActive
      ? getColor(p.thumbBackgroundActive || DEFAULT_ACTIVE_THUMB_COLOR)(p)
      : getColor(p.thumbBackgroundInactive || DEFAULT_INACTIVE_THUMB_COLOR)(p)};
  left: ${p =>
    ms(
      p.isActive
        ? (p.width || DEFAULT_WIDTH) -
            ((p.height || DEFAULT_HEIGHT) - OFFSET * 2) -
            OFFSET
        : OFFSET,
    )};
`;

export const thumbNative = css<StyledProps>`
  ${thumbBase};
`;
